document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.echo-faq' ).forEach( initFaq );
} );

function initFaq( faq ) {
	faq.querySelectorAll( '.echo-faq__title' ).forEach( ( title ) => {
		title.addEventListener( 'click', () => toggleItem( faq, title ) );
		title.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Enter' || e.key === ' ' ) {
				e.preventDefault();
				toggleItem( faq, title );
			}
		} );
	} );
}

function toggleItem( faq, title ) {
	const isExpanded = title.getAttribute( 'aria-expanded' ) === 'true';

	// Close all items in this FAQ block (accordion behaviour)
	faq.querySelectorAll( '.echo-faq__title' ).forEach( ( t ) => {
		closeItem( t );
	} );

	// Open clicked item if it was closed
	if ( ! isExpanded ) {
		openItem( title );
	}
}

function openItem( title ) {
	const content = document.getElementById( title.getAttribute( 'aria-controls' ) );
	if ( ! content ) return;

	title.setAttribute( 'aria-expanded', 'true' );

	const iconClosed = title.querySelector( '.echo-faq__icon-closed' );
	const iconOpened = title.querySelector( '.echo-faq__icon-opened' );
	if ( iconClosed ) iconClosed.hidden = true;
	if ( iconOpened ) iconOpened.hidden = false;

	// Wrap content in inner div for padding (avoids padding-in-transition issues)
	if ( ! content.querySelector( '.echo-faq__content-inner' ) ) {
		const inner = document.createElement( 'div' );
		inner.className = 'echo-faq__content-inner';
		while ( content.firstChild ) inner.appendChild( content.firstChild );
		content.appendChild( inner );
	}

	content.hidden = false;
	content.setAttribute( 'aria-hidden', 'false' );
	content.style.maxHeight = content.scrollHeight + 'px';
}

function closeItem( title ) {
	const content = document.getElementById( title.getAttribute( 'aria-controls' ) );
	if ( ! content ) return;

	title.setAttribute( 'aria-expanded', 'false' );

	const iconClosed = title.querySelector( '.echo-faq__icon-closed' );
	const iconOpened = title.querySelector( '.echo-faq__icon-opened' );
	if ( iconClosed ) iconClosed.hidden = false;
	if ( iconOpened ) iconOpened.hidden = true;

	content.setAttribute( 'aria-hidden', 'true' );
	content.style.maxHeight = '0';

	content.addEventListener( 'transitionend', () => {
		if ( content.style.maxHeight === '0px' ) {
			content.hidden = true;
		}
	}, { once: true } );
}